export default "__VITE_ASSET__DeVZBucc__"